import type {SVGProps} from 'react'

const SvgSupport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={24}
    height={24}
    fill={'none'}
    viewBox={'0 0 24 24'}
    {...props}
  >
    <path
      fill={'currentColor'}
      d={'m7.024 18.265.407.474.575-.492-.593-.471zM5 20l-.407-.474-1.283 1.099H5zm14.375-8A7.375 7.375 0 0 1 12 19.375v1.25A8.625 8.625 0 0 0 20.625 12zM12 4.625A7.375 7.375 0 0 1 19.375 12h1.25A8.625 8.625 0 0 0 12 3.375zM4.625 12A7.375 7.375 0 0 1 12 4.625v-1.25A8.625 8.625 0 0 0 3.375 12zm2.788 5.776A7.36 7.36 0 0 1 4.625 12h-1.25a8.61 8.61 0 0 0 3.26 6.754zm-2.006 2.698L7.43 18.74l-.813-.949-2.025 1.736zM12 19.376H5v1.25h7z'}
    />
    <circle
      cx={12}
      cy={12}
      r={0.625}
      stroke={'currentColor'}
      strokeWidth={1.25}
    />
    <circle
      cx={15}
      cy={12}
      r={0.625}
      stroke={'currentColor'}
      strokeWidth={1.25}
    />
    <circle
      cx={9}
      cy={12}
      r={0.625}
      stroke={'currentColor'}
      strokeWidth={1.25}
    />
  </svg>
)
export default SvgSupport
